import React from 'react';
import { formActions, useAppDispatch, useAppSelector } from '../../data/store';
import { getRandomIcons } from '../../domain/icons-provider';

const RandomizeButton = () => {

    const dispatch = useAppDispatch();
    const iconsData = useAppSelector(store => store.root.iconsData);
    const icons = useAppSelector(store => store.form.icons);
    const category = useAppSelector(store => store.root.category);

    /**
     * download the result SVG
     */
    const randomizeHandler = async () => {

        const updatedIcons = await getRandomIcons(iconsData, category, icons.length);

        dispatch(
            formActions.main({
                icons: updatedIcons,
            })
        );
    };

    return (
        <button
            type="button"
            className="bg-green-500 text-gray-100 rounded-full px-10 py-3 mx-2 flex items-center justify-center whitespace-nowrap"
            onClick={ randomizeHandler }>Randomize</button>
    )
};

export default RandomizeButton;